<template>
    <FormInput :context="context">
        <PrimeVueInputCalendar
            v-model="value"
            v-bind="attributes"
            v-on="$listeners"
            @blur="context.blurHandler"
        />
        <div v-if="help" :class="classNames" v-text="help" />
    </FormInput>
</template>

<script>
import FormInputMixin from "@/components/forms/inputs/mixins/FormInputMixin";
import PrimeVueInputCalendar from "primevue/calendar";
import { DateTime } from "luxon";

export default {
    components: { PrimeVueInputCalendar },
    mixins: [FormInputMixin],
    props: {
        locale: {
            // BCP 47 language tag(s)
            type: String,
            default: "en-US",
        },
        timezone: {
            // IANA time zone https://www.iana.org/time-zones
            type: String,
            default: null,
        },
        showTime: {
            type: Boolean,
            default: true,
        },
        timeOnly: {
            type: Boolean,
            default: false,
        },
        allowPast: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            language: {
                today: "Today",
            },
        };
    },
    watch: {
        timezone() {
            this.context.model = this.valueWithTimezoneAsString;
        },
    },
    computed: {
        defaults() {
            let showOtherMonths;
            let selectOtherMonths;

            if (this.allowPast === true) {
                selectOtherMonths = showOtherMonths = true;
            } else {
                selectOtherMonths = showOtherMonths = false;
            }

            return {
                showTime: this.showTime,
                timeOnly: this.timeOnly,
                showOtherMonths,
                selectOtherMonths,
                showButtonBar: true,
                hideOnDateTimeSelect: true,
                manualInput: false,
                locale: "en",
            };
        },
        help() {
            const local = DateTime.local().offsetNameLong;
            const timezoned = DateTime.local().setZone(
                this.timezone
            )?.offsetNameLong;

            if (timezoned && local !== timezoned) {
                return `Timezone: ${timezoned}`;
            }

            return false;
        },
        classNames() {
            return ["supplios-form-field-datetime-help"].concat(
                this.context.classes.help
            );
        },
        valueWithTimezone() {
            return this.parseValueWithTimezone(this.value);
        },
        valueWithTimezoneAsString() {
            return this.valueWithTimezone?.toISO();
        },
    },
    methods: {
        onValueChanged() {
            this.context.model = this.valueWithTimezoneAsString;
        },
        parseValueWithTimezone(value) {
            if (value) {
                value = DateTime.fromJSDate(value);

                if (value.isValid) {
                    value = value.setLocale(this.locale);

                    if (this.timezone && this.timezone !== "") {
                        value = value.setZone(this.timezone);
                    }
                } else {
                    value = null;
                }
            } else {
                value = null;
            }

            return value;
        },
    },
    mounted() {
        if (this.timeOnly === "time") {
            this.language.today = "Now";
        }

        this.$nextTick(() => {
            const parsedValue = DateTime.fromISO(this.context.model);

            if (parsedValue.isValid) {
                this.value = parsedValue.toJSDate();
            }
        });
    },
};
</script>